import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const DevIndicator = () => <Wrapper>dev</Wrapper>;

DevIndicator.propTypes = {
    env: PropTypes.string,
};

const Wrapper = styled.span`
    z-index: 10000000;
    border-radius: 5px;
    background-color: darkorange;
    position: fixed;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    color: white;
`;

export default DevIndicator;
